@if(!showMailConfirm){
<div class="login-body text-dark">
  <div class="login-wrapper">
    <div class="login-panel">
      <a [routerLink]="['/']" class="logo">
        <img
          src="assets/classjax-logo-dark.svg"
          alt="ClassJax Logo"
          class="img-fluid"
          style="width: 150px"
        />
      </a>

      @if (inviteDetails(); as invite) {
        <h2>{{ invite.class_name }}</h2>
        <p class="text-muted mb-3">Invited by {{ invite.teacher_name }}</p>
      } @else {
        <h2>Create Teacher Account</h2>
        <p class="text-muted mb-3">Teachers can create classes, lesson plans, and more.</p>
      }

      @if(providers.length){
      <div class="providers mt-3">
        @for(p of providers; track p.id) {
        <button
          (click)="signupWithProvider(p.id)"
          class="btn btn-lg btn-outline-secondary w-100 mb-2 d-flex align-items-center justify-content-center gap-2"
          [disabled]="busy"
        >
          @if(p.id === 'google') {
          <svg
            width="18"
            height="18"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          } Sign up with {{ p.label }}
        </button>
        }
      </div>

      <div class="position-relative my-4" style="width: 350px">
        <div class="d-flex align-items-center text-muted">
          <div class="flex-grow-1">
            <hr style="border-top: 2px solid #e0e0e0; margin: 0; opacity: 1" />
          </div>
          <div class="px-4" style="font-size: 0.875rem; font-weight: 500">
            OR
          </div>
          <div class="flex-grow-1">
            <hr style="border-top: 2px solid #e0e0e0; margin: 0; opacity: 1" />
          </div>
        </div>
      </div>
      }

      <form
        class="login-form"
        [formGroup]="signupForm"
        (ngSubmit)="signUp()"
        novalidate
        autocomplete="off"
      >
        <p>Already have an account? <a routerLink="/signin" [queryParams]="inviteToken() ? { invite: inviteToken() } : {}">Sign in</a></p>
        <div class="form-floating">
          <input
            type="email"
            class="form-control form-control-top"
            [class.bg-light]="emailLocked()"
            id="email"
            placeholder="name@example.com"
            autocomplete="off"
            formControlName="email"
            [attr.arch-auto-focus]="!emailLocked() ? '' : null"
          />
          <label for="email" class="text-dark">Email</label>
        </div>
        @if (emailLocked()) {
          <small class="text-muted d-block mt-1 mb-2">
            This email is from your class invitation.
          </small>
        }
        <div class="form-floating">
          <input
            type="password"
            class="form-control form-control-inside"
            id="password"
            placeholder="Password"
            autocomplete="off"
            formControlName="password"
          />
          <label for="password" class="text-dark">Password</label>
        </div>
        <div class="form-floating">
          <input
            type="password"
            class="form-control form-control-bottom"
            id="passwordConfirm"
            placeholder="Confirm Password"
            autocomplete="off"
            formControlName="passwordConfirm"
          />
          <label for="passwordConfirm" class="text-dark"
            >Confirm Password</label
          >
        </div>
        <div class="my-2">
          <app-turnstile formControlName="captchaToken"></app-turnstile>
        </div>
        @if(error){
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
        }
        <button
          type="submit"
          class="w-100 btn btn-lg btn-primary text-white"
          [class.fk-busy]="busy"
          [disabled]="signupForm.invalid || busy"
        >
          SIGN UP
        </button>
      </form>
    </div>
  </div>
</div>
} @else {
<div class="login-body text-dark">
  <div class="login-wrapper">
    <div class="login-panel text-center">
      <a [routerLink]="['/']" class="logo">
        <img
          src="assets/classjax-logo-dark.svg"
          alt="ClassJax Logo"
          class="img-fluid"
          style="width: 150px"
        />
      </a>
      <h2 class="mt-4">Welcome</h2>
      <p class="lead">Please check your email for a verification link.</p>
    </div>
  </div>
</div>
}
